import { useEffect, useState } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import Accordion from '../../components/Accordion/Accordion';
import { myProfileData, bonusData, DepositData, ProductsData, affiliateDate, securityData } from "./faqData";
import { myProfileDataBD, bonusDataBD, DepositDataBD, ProductsDataBD, affiliateDateBD, securityDataBD, securityDataBazziadda, bonusDataBAdda } from "./faqdatabetdaily";
import { bonusData39, securityData39 } from "./FAQfomo";
import FAQ39 from "./FAQ39";
import { security46 } from "./Fun88FAQ";
import FAQ46 from "./FAQ46";
import FAQ47 from "./FAQ47";
import { getDamain } from "src/util/commonfun";
import FAQ61 from "./FAQ61";
import { MetaProps, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { useLocation } from "react-router-dom";
import { otherPagesSEOData } from "src/config/seo_api";

function FAQ(props: any) {

    const { app: {
        brandId
    }, theme } = props
    const { config: { showAPISEOData } } = theme;
    const [seoObjects, setseoObjects] = useState({} as MetaProps);
    const _location = useLocation();

    let WebsiteName = ''
    let WebsiteLink = ''
    switch (props.app.brandId) {
        case 31:
            WebsiteName = 'Yolo247';
            WebsiteLink = 'www.yolo247.live'
            break;
        case 32:
            WebsiteName = 'Yolo247';
            WebsiteLink = 'www.a-yolo247.site'
            break;
        case 33:
            WebsiteName = 'IW247';
            WebsiteLink = 'm.iw247.com'
            break;
        case 34:
            WebsiteName = 'BETDAILY';
            WebsiteLink = 'www.betdaily.club'
            break;
        case 39:
            WebsiteName = 'FOMO7';
            WebsiteLink = 'www.fomo7.co'
            break;
        case 46:
            WebsiteName = 'FUN88';
            WebsiteLink = 'www.fun88.site'
            break;
        case 47:
            WebsiteName = 'FUN88';
            WebsiteLink = 'www.fun88.live'
            break;
    }

    let domainURL = getDamain(brandId)

    const { config: { showAffiliate } } = theme;

    useEffect(() => {
        window.scrollTo(0, 0)
    })

    //for SEO
    useEffect(() => {
        if (showAPISEOData) {
            const getSeoData = otherPagesSEOData();
            const pathName = _location.pathname;

            getSeoData.then(resp => {
                const { objects } = resp;
                const seoData = objects.find((obj: any) => {
                    const { metadata = {} } = obj;
                    if (metadata.pathname && metadata.pathname === pathName) {
                        return obj;
                    }

                }) || {};

                const { metadata = {} } = seoData;
                setseoObjects(metadata);

            }).catch(error => console.log(`[${pathName}]:Error in SEO API`))
        }
    }, []);

    return (
        <>
            {showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}

            {(brandId === 39 || brandId === 40) ? <FAQ39 /> 
            : brandId == 46 ? <FAQ46 /> 
            : brandId == 47 ? <FAQ47 /> 
            : brandId == 61 ? <FAQ61 /> 
            : (
                <>
                    <ContentWrapper>
                        <AccordionHead>My Account</AccordionHead>
                        {brandId == 33 || brandId == 34 ?
                            (myProfileDataBD(brandId) || []).map((faq) => (
                                <Accordion
                                    key={faq.id}
                                    title={faq?.question}
                                    content={() => ({ __html: faq?.answer })}
                                    lists={faq?.lists}
                                // redirect={faq?.redirect}
                                />
                            )) :
                            (myProfileData(brandId) || []).map((faq) => (
                                <Accordion
                                    key={faq.id}
                                    title={faq?.question}
                                    content={() => ({ __html: faq?.answer })}
                                    lists={faq?.lists}
                                // redirect={faq?.redirect}
                                />
                            ))}

                        <AccordionHead>Bonus Program</AccordionHead>

                        {brandId == 33 ? bonusDataBAdda.map((elm) => (
                            <Accordion
                                key={elm.id}
                                title={elm?.question}
                                content={() => ({ __html: elm?.answer })}
                                lists={elm?.lists}
                            />
                        )) :
                            brandId == 34 ?
                                (bonusDataBD.map((faq) => (
                                    <Accordion
                                        key={faq.id}
                                        title={faq?.question}
                                        content={() => ({ __html: faq?.answer })}
                                        lists={faq?.lists}
                                    />
                                ))) :
                                (brandId == 39 || brandId == 40) ?
                                    (bonusData39.map((faq) => (
                                        <Accordion
                                            key={faq.id}
                                            title={faq?.question}
                                            content={() => ({ __html: faq?.answer })}
                                            lists={faq?.lists}
                                        />
                                    ))) :
                                    (bonusData.map((faq) => (
                                        <Accordion
                                            key={faq.id}
                                            title={faq?.question}
                                            content={() => ({ __html: faq?.answer })}
                                            lists={faq?.lists}
                                        />
                                    )))}
                        <AccordionHead>Deposit & Withdrawal</AccordionHead>


                        {brandId == 33 || brandId == 34 ? (DepositDataBD(brandId) || []).map((faq) => (
                            <Accordion
                                key={faq.id}
                                title={faq?.question}
                                content={() => ({ __html: faq?.answer })}
                                lists={faq?.lists}
                            />
                        )) : (DepositData(brandId) || []).map((faq) => (
                            <Accordion
                                key={faq.id}
                                title={faq?.question}
                                content={() => ({ __html: faq?.answer })}
                                lists={faq?.lists}
                            />
                        ))}
                        <AccordionHead>Products</AccordionHead>



                        {brandId == 33 || brandId == 34 ? (ProductsDataBD.map((faq) => (
                            <Accordion
                                key={faq.id}
                                title={faq?.question}
                                content={() => ({ __html: faq?.answer })}
                                lists={faq?.lists}
                            />
                        ))) : (ProductsData.map((faq) => (
                            <Accordion
                                key={faq.id}
                                title={faq?.question}
                                content={() => ({ __html: faq?.answer })}
                                lists={faq?.lists}
                            />
                        )))}
                        {showAffiliate && (<><AccordionHead>Affiliate</AccordionHead>
                            {brandId == 33 || brandId == 34 ? (affiliateDateBD.map((faq) => (
                                <Accordion
                                    key={faq.id}
                                    title={faq?.question}
                                    content={() => ({ __html: faq?.answer })}
                                    lists={faq?.lists}
                                />
                            ))) : (affiliateDate.map((faq) => (
                                <Accordion
                                    key={faq.id}
                                    title={faq?.question}
                                    content={() => ({ __html: faq?.answer })}
                                    lists={faq?.lists}
                                />
                            )))}</>)}
                        <AccordionHead>Security</AccordionHead>
                        {brandId == 33 ? securityDataBazziadda.map((elm) => (
                            <Accordion
                                key={elm.id}
                                title={elm?.question}
                                content={() => ({ __html: elm?.answer })}
                                lists={elm?.lists}
                            />
                        )) :

                            brandId == 34 ? (securityDataBD.map((faq) => (
                                <Accordion
                                    key={faq.id}
                                    title={faq?.question}
                                    content={() => ({ __html: faq?.answer })}
                                    lists={faq?.lists}
                                />
                            ))) :
                                (brandId == 39 || brandId == 40) ? (securityData39.map((faq) => (
                                    <Accordion
                                        key={faq.id}
                                        title={faq?.question}
                                        content={() => ({ __html: faq?.answer })}
                                        lists={faq?.lists}
                                    />
                                ))) : (brandId == 46 || brandId == 47) ? (security46.map((faq) => (
                                    <Accordion
                                        key={faq.id}
                                        title={faq?.question}
                                        content={() => ({ __html: faq?.answer })}
                                        lists={faq?.lists}
                                    />
                                ))) : (securityData.map((faq) => (
                                    <Accordion
                                        key={faq.id}
                                        title={faq?.question}
                                        content={() => ({ __html: faq?.answer })}
                                        lists={faq?.lists}
                                    />
                                )))}
                    </ContentWrapper></>
            )}
        </>
    );



}
export default withTheme(withAppContext(FAQ));



const AccordionHead = styled.h1`
        font-size: 15px;
        color: #f4a322;
        margin-top:10px;
        margin: 1px 0px;
        padding: 5px 15px;
        background-color: #0000008a;
        `;
const ContentWrapper = styled.div`
	max-width: 800px;
	margin: 0 auto;
	font-size: 12px;
	padding: 1em 1.25em;

    h1{
        color: #EEBC15;
        
    }

    p,
	h3,
	h4,
	h5,
	h6 {
		color: #fff;
	}

	h1 {
		font-size: 18px;
	}

	h2 {
		font-size: 16px;
	}

	h3 {
		font-size: 14px;
	}

	ul ul,
	ol {
		margin: 1em 0;
	}

	li {
        color: #fff;
	}

	a {
		color: #EEBC15;
		text-decoration: underline;
	}

    span{
        font-weight: 700;
    }
`;
